import aT from '../const/action-type'
import initial from '../store/initial'

export default (state = initial.calendarMultiSelect, action) => {
  switch (action.type) {
    case aT.SET_CALENDAR_MULTI_SELECT:
      return action.data
    case aT.RESET_STORE:
      return initial.calendarMultiSelect
    case aT.SWITCH_WORKSPACE:
      return initial.calendarMultiSelect
    default:
      return state
  }
}
